<template>
  <div>
    <AlertBox v-if="isSuccess">
      <b>Seu comentário foi enviado</b> e ficará disponível em breve!
    </AlertBox>

    <form
      v-else
      class="comment-reply-container"
      @submit.prevent="submitComment"
    >
      <picture class="avatar embed-responsive embed-responsive-1by1">
        <img 
        class="embed-responsive-item" 
        :src="user.avatar" />
      </picture>     
    
      <div class="comment-body">
        <textarea
          v-model="comment"
          class="form-control w-100"
          @keydown.enter.prevent="submitComment"
          :placeholder="placeholder"
          :disabled="isLoading"
          ref="textarea"
        ></textarea>

        <div class="d-flex align-items-center">
          <button
            type="submit"
            class="submit-btn"
            :disabled="isLoading || comment.length < 3"
          >
            responder
          </button>

          <LoadingIcon v-if="isLoading" class="ml-3" style="width: 10px" />
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import LoadingIcon from "@/components/layout/LoadingIcon";
import AlertBox from "@/components/layout/AlertBox";

export default {
  props: {
    placeholder: { type: String, default: "" },
    bookId: { type: Number, default: null },
    courseGroupId: { type: Number, default: null },
    courseId: { type: Number, default: null },
    type: { type: String, default: "" },
  },

  components: {
    LoadingIcon,
    AlertBox
  },

  data: () => ({
    comment: '',
    isLoading: false,
    isSuccess: false
  }),

  computed: {
    ...mapGetters("user", ["user"]),

    isReply() {
      return !!this.courseGroupId;
    }
  },

  watch: {
    courseId () {
      this.isSuccess = false
    }
  },

  methods: {
    ...mapActions("courseGroup", [
      "createCourseGroup",
      "createCourseGroupReply"
    ]),

    async submitComment() {
      if (this.comment.length < 3) {
        return null;
      }

      this.isLoading = true;

      const data = {
        courseId: this.courseId,
        type: this.type,      
        comment: this.comment
      };
      
      try {
        if (this.isReply) {
          data["courseGroupId"] = this.courseGroupId;
          data["type"] = 'reply';
          
          await this.createCourseGroupReply(data);
        } else {
          await this.createCourseGroup(data);
        }

        this.comment = "";
        this.isLoading = false;
        this.isSuccess = true;

        this.$emit("success");
      } catch (err) {
        this.isLoading = false;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.comment-reply-container {
  display: flex;

  .avatar {
    width: 30px;
    height: 30px;
    border-radius: 100%;
    flex-shrink: 0;
    margin-right: 10px;
  }

  .comment-body {
    width: 100%;
    position: relative;

    textarea {
      margin-bottom: 10px;
      &:focus {
        outline: 0 0 0;
        box-shadow: 0 0 0;
        border: 1px solid #ff8800;
      }
    }

    .submit-btn {
      background-color: #ff8800;
      color: #fff;
      padding: 4px 12px;
      font-family: "Poppins";
      font-weight: 600;
      font-size: 13px;
      border-radius: 3px;
    }
  }
}
</style>
